import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import './assets/css/tailwind.output.css'
import App from './App'
import { SidebarProvider } from './context/SidebarContext'
import { SnackbarProvider } from './context/SnackbarContext'
import { AuthProvider } from './context/AuthContext'
// import { StripeProvider } from './context/StripeContext'
import ThemedSuspense from './components/ThemedSuspense'
import { Windmill } from '@windmill/react-ui'
import * as serviceWorker from './serviceWorker'
import Theme from './Theme'

ReactDOM.render(
  <SidebarProvider>
    <SnackbarProvider>
      {/* <StripeProvider> */}
        <AuthProvider>
          <Suspense fallback={<ThemedSuspense />}>
            <Windmill usePreferences theme={Theme}>
              <App />
            </Windmill>
          </Suspense>
        </AuthProvider>
      {/* </StripeProvider> */}
    </SnackbarProvider>
  </SidebarProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
